module.exports = __webpack_public_path__ + "banner-disputa360-mobile.png";